import styled from "styled-components";
import { RAButtonSecondary, RATypography } from "@/components/customs";
import { Col, Grid, Row } from "antd";
import { useTrackVisibility } from "react-intersection-observer-hook";

const { useBreakpoint } = Grid;

export function ServiceAirFreightRequestQuote({ request_freight_quote = {}, onRequestAirFreight }) {
	const screens = useBreakpoint();
	const [ref] = useTrackVisibility();

	return (
		<HomeContactContainer
			ref={ref}
			bgImage={
				screens.xs
					? request_freight_quote?.mobile_background_photo
					: request_freight_quote?.desktop_background_photo
			}
		>
			<WrapperContent>
				<RATypography
					variant={screens?.md ? "h2" : "h3"}
					color="#222222"
					bottom={screens.xs ? 16 : 24}
					style={{ textAlign: "center" }}
				>
					{request_freight_quote?.title || ""}
				</RATypography>
				<Row justify="center">
					<Col lg={16} md={20} sm={24} xs={24}>
						<RATypography variant="body3" color="#595959" bottom={30} align="center">
							{request_freight_quote?.description || ""}
						</RATypography>
					</Col>
				</Row>
				<WrapperQuote className="animate__animated animate__fadeInUp">
					<RAButtonSecondary
						background="#fff"
						title={request_freight_quote?.button_content || "REQUEST"}
						onClick={() => onRequestAirFreight()}
						width="100%"
						border="none"
					/>
				</WrapperQuote>
			</WrapperContent>
		</HomeContactContainer>
	);
}

const HomeContactContainer = styled.div`
	width: 100%;
	position: relative;
	border-radius: 12px;
	background-image: ${(props) => `url(${props.bgImage || "/images/services/air-freight/air-freight-mask.png"})`};
	background-size: cover;
	background-position: center center;
`;
const WrapperContent = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	padding: clamp(46px, 10vw, 72px) clamp(16px, 4vw, 64px);
	@media (max-width: 576px) {
		min-height: 320px;
	}
`;
const WrapperQuote = styled.div`
	max-width: 280px;
	--animate-duration: 3s;
`;
